import { AccountUsageWidget } from './AccountUsageWidget'
import { AskQuestionsWidget } from './AskQuestionsWidget'
import { SeparateTransactionsWidget } from './SeparateTransactionsWidget'
import { EmptyMonthsWidget } from './EmptyMonthsWidget'
import { ManualTransactionsWidget } from './ManualTransactionsWidget'
import { StatementUploadWidget } from './StatementUploadWidget'
import { CategorizeTransactionsWidget } from './CategorizeTransactionsWidget'
import { ConfirmSortedAutomaticallyWidget } from './ConfirmSortedAutomaticallyWidget'
import { ConfirmTransactionCategoryWidget } from './ConfirmTransactionCategoryWidget'
import { ConnectFinancialAccountsWidget } from './ConnectFinancialAccountsWidget'
import { UnconnectedAccountWidget } from './UnconnectedAccountWidget'
import { WaitForAutoCategorizationWidget } from './WaitForAutoCategorizationWidget'
import { WaitForReconciliationWidget } from './WaitForReconciliationWidget'
import { AdviserToolName } from '../../lib/constants'
import type { WidgetComponent } from './types'

/** Which widget answers which tool. A tool absent here draws as a plain tool run. */
export const WIDGET_REGISTRY: Record<string, WidgetComponent> = {
  add_unconnected_account: UnconnectedAccountWidget,
  ask_questions: AskQuestionsWidget,
  confirm_account_usage: AccountUsageWidget,
  add_manual_transactions: ManualTransactionsWidget,
  confirm_empty_months: EmptyMonthsWidget,
  request_bank_statements: StatementUploadWidget,
  categorize_transactions: CategorizeTransactionsWidget,
  confirm_sorted_automatically: ConfirmSortedAutomaticallyWidget,
  confirm_transaction_category: ConfirmTransactionCategoryWidget,
  connect_financial_accounts: ConnectFinancialAccountsWidget,
  separate_transactions: SeparateTransactionsWidget,
  wait_for_auto_categorization: WaitForAutoCategorizationWidget,
  wait_for_reconciliation: WaitForReconciliationWidget,
}

/** Whether a tool's card splits Haven's text: the text before it is drawn above it. */
export const splitsText = (toolName: string): boolean =>
  Boolean(WIDGET_REGISTRY[toolName]) ||
  toolName === AdviserToolName.ShowHighlights

/** Where Haven's text splits when drawn. The Yes and No buttons count here but not in `splitsText`, which also keys citations to a card. */
export const splitsDrawnText = (toolName: string): boolean =>
  splitsText(toolName) || toolName === AdviserToolName.OfferYesNo
